var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:[_vm.classList, { 'use-stroke': _vm.useStroke }],attrs:{"aria-labelledby":_vm.iconName,"viewBox":_vm.viewBox,"xmlns":"http://www.w3.org/2000/svg","role":"presentation","width":"18","height":"18"}},[_c(_vm.componentName,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }